import { Card, Image } from 'react-bootstrap';

const ImageWithFooter = ({ src, alt, footer, width = 300 }) => {
  if (!src) return null;
  return (
    <Card style={{ width }} className="shadow-sm">
      <Image
        src={src}
        alt={alt || ''}
        fluid
        rounded
        thumbnail
        style={{ width: '100%' }}
      />
      {footer && (
        <Card.Footer className="py-1 small text-muted " title={footer}>
          {footer}
        </Card.Footer>
      )}
    </Card>
  );
};

export default ImageWithFooter;